// ganttConstants.ts
export const ROW_HEIGHT = 50; //48
//export const ROW_HEIGHT = 60;
export const ROWS_PER_WORK = 3;
//export const WORK_COL_WIDTH = 256;
export const WORK_COL_WIDTH = 300;
export const TYPE_COL_WIDTH = 90;
